import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import { config } from './config'

Vue.config.productionTip = false


Vue.mixin({
  data() {
    return {
      get config() {
        return config
      }
    }
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
